export default __webpack_public_path__ + "static/kent-c-dodds-77fd4ca2c3bf19802dcbb9bc5d99fda6.jpg";